import { connect } from 'react-redux';
import { Route as DisconnectedRoute, Switch as DisconnectedSwitch } from 'react-router-dom';

const mapStateToProps = ({ router }) => ({ ...router });

export const Route = connect(mapStateToProps)(DisconnectedRoute);
export const Switch = connect(mapStateToProps)(DisconnectedSwitch);
